"use strict";

exports.__esModule = true;
exports.SortableRow = void 0;
var _core = require("@blueprintjs/core");
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _excluded = ["children", "deleteSelf", "onDragEnd", "onDragLeave"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var SortableRow = exports.SortableRow = function SortableRow(_ref) {
  var children = _ref.children,
    deleteSelf = _ref.deleteSelf,
    onDragEnd = _ref.onDragEnd,
    onDragLeave = _ref.onDragLeave,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    isDraggable = _useState[0],
    setDraggable = _useState[1];
  return /*#__PURE__*/_react["default"].createElement(_styles.Row, _extends({
    draggable: isDraggable,
    onDragEnd: onDragEnd,
    onDragLeave: onDragLeave
  }, extra), /*#__PURE__*/_react["default"].createElement(_styles.Row, null, /*#__PURE__*/_react["default"].createElement(_styles.Icon, {
    icon: "drag-handle-vertical",
    onMouseEnter: function onMouseEnter() {
      return setDraggable(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setDraggable(false);
    }
  }), children), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    "data-testid": "RemoveRowButton-" + extra["data-testid"],
    onClick: function onClick() {
      return deleteSelf();
    },
    icon: "trash",
    minimal: true,
    small: true
  }));
};